/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Hero_BadgeInputs */

const vi_shop_home_hero_badge = /** @type {(inputs: Shop_Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhãn`)
};

/**

* @param {Shop_Home_Hero_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_hero_badge = /** @type {((inputs?: Shop_Home_Hero_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Hero_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_hero_badge(inputs)
});